import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { apis } from './apis';
import { rootRouteRef } from './routes';

export const almServicesPlugin = createPlugin({
  id: 'alm-services',
  routes: {
    root: rootRouteRef,
  },
  apis: apis,
});

export const CreateDatabasePage = almServicesPlugin.provide(
  createRoutableExtension({
    name: 'CreateDatabasePage',
    component: () =>
      import('./pages/create-databases').then(m => m.CreateDatabasePage),
    mountPoint: rootRouteRef,
  }),
);

export const ListPageRequests = almServicesPlugin.provide(
  createRoutableExtension({
    name: 'ListPageRequests',
    component: () => import('./pages/requests').then(m => m.ListRequests),
    mountPoint: rootRouteRef,
  }),
);
export const CreateServiceAccountsPage = almServicesPlugin.provide(
  createRoutableExtension({
    name: 'CreateServiceAccountsPage',
    component: () =>
      import('./pages/service-accounts').then(m => m.CreateServiceAccountsPage),
    mountPoint: rootRouteRef,
  }),
);

export const AddDatabasePermissionsPage = almServicesPlugin.provide(
  createRoutableExtension({
    name: 'AddDatabasePermissionsPage',
    component: () =>
      import('./pages/add-database-permissions').then(
        m => m.AddDatabasePermissionsPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
